import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2 } from "lucide-react";
import { CarrierFormData, usStates } from "./CarrierSignup";

interface Props {
  handleInputChange: (field: keyof CarrierFormData, value: any) => void;
  formData: CarrierFormData;
}

export function CompanyInfoCard({ formData, handleInputChange }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Building2 className="h-5 w-5" />
          Company Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="companyName">Company Name *</Label>
          <Input
            id="companyName"
            value={formData.companyName}
            onChange={(e) => handleInputChange("companyName", e.target.value)}
            placeholder="Enter company name"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="dotNumber">DOT Number *</Label>
            <Input
              id="dotNumber"
              value={formData.dotNumber}
              onChange={(e) => handleInputChange("dotNumber", e.target.value)}
              placeholder="DOT-123456"
            />
          </div>
          <div>
            <Label htmlFor="mcNumber">MC Number *</Label>
            <Input
              id="mcNumber"
              value={formData.mcNumber}
              onChange={(e) => handleInputChange("mcNumber", e.target.value)}
              placeholder="MC-789012"
            />
          </div>
        </div>
        <div>
          <Label htmlFor="federalTaxId">Federal Tax ID *</Label>
          <Input
            id="federalTaxId"
            value={formData.federalTaxId}
            onChange={(e) => handleInputChange("federalTaxId", e.target.value)}
            placeholder="XX-XXXXXXX"
          />
        </div>
        <div>
          <Label htmlFor="businessAddress">Business Address *</Label>
          <Input
            id="businessAddress"
            value={formData.businessAddress}
            onChange={(e) =>
              handleInputChange("businessAddress", e.target.value)
            }
            placeholder="Street address"
          />
        </div>
        <div className="grid grid-cols-3 gap-4">
          <div>
            <Label htmlFor="city">City *</Label>
            <Input
              id="city"
              value={formData.city}
              onChange={(e) => handleInputChange("city", e.target.value)}
              placeholder="City"
            />
          </div>
          <div>
            <Label htmlFor="state">State *</Label>
            <select
              id="state"
              value={formData.state}
              onChange={(e) => handleInputChange("state", e.target.value)}
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background"
            >
              <option value="">Select State</option>
              {usStates.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>
          <div>
            <Label htmlFor="zipCode">ZIP Code *</Label>
            <Input
              id="zipCode"
              value={formData.zipCode}
              onChange={(e) => handleInputChange("zipCode", e.target.value)}
              placeholder="12345"
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="phoneNumber">Phone Number *</Label>
            <Input
              id="phoneNumber"
              value={formData.phoneNumber}
              onChange={(e) => handleInputChange("phoneNumber", e.target.value)}
              placeholder="(555) 123-4567"
            />
          </div>
          <div>
            <Label htmlFor="email">Email Address *</Label>
            <Input
              id="email"
              type="email"
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              placeholder="contact@company.com"
            />
          </div>
        </div>
        <div>
          <Label htmlFor="website">Website</Label>
          <Input
            id="website"
            value={formData.website}
            onChange={(e) => handleInputChange("website", e.target.value)}
            placeholder="https://www.company.com"
          />
        </div>
      </CardContent>
    </Card>
  );
}
